/** localStorage that never throws (private mode, blocked storage, sandboxed iframes). */
export const storage = {
  get(key: string): string | null {
    try { return window.localStorage.getItem(key); } catch { return null; }
  },
  set(key: string, value: string) {
    try { window.localStorage.setItem(key, value); } catch { /* storage unavailable */ }
  },
  remove(key: string) {
    try { window.localStorage.removeItem(key); } catch { /* storage unavailable */ }
  },
  getJSON<T>(key: string): T | null {
    const v = storage.get(key);
    if (!v) return null;
    try { return JSON.parse(v) as T; } catch { return null; }
  },
  setJSON(key: string, value: unknown) { storage.set(key, JSON.stringify(value)); },
};
